// How each browser words a failed lazy chunk. The fallback for `installChunkReload`
// (src/router/chunkReload.ts), whose primary signal is Vite's `vite:preloadError`.
const CHUNK_LOAD_ERROR_MESSAGES = [
  'Failed to fetch dynamically imported module', // Chrome, Edge
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari, network failure
  'is not a valid JavaScript MIME type', // Safari, the CDN answered the missing chunk with index.html
  'Unable to preload CSS', // Vite, the chunk's stylesheet is missing
]

export const isChunkLoadErrorMessage = (message: string | undefined): boolean =>
  !!message && CHUNK_LOAD_ERROR_MESSAGES.some((text) => message.includes(text))
